//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";


//-------------------------------------------------------------------------------------------------- Interfaces
interface AlertConfirmationSliceInterface {
    show: boolean;
    onPressBtnPrimary?: Function;
    onPressBtnSecondary?: Function;
    title?: string;
    message: string;
    subText?: string;
    subMessage?: string;
    btnPrimaryText?: string;
    btnSecondaryText?: string;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const alertConfirmationSliceInitialState = {
    show: false,
    onPressBtnPrimary: undefined,
    onPressBtnSecondary: undefined,
    title: "",
    message: "",
    subText: "",
    subMessage: "",
    btnPrimaryText: undefined,
    btnSecondaryText: undefined,
} as AlertConfirmationSliceInterface;



//-------------------------------------------------------------------------------------------------- Slice
const alertConfirmationSlice = createSlice({
    name: "alertConfirmation",
    initialState: alertConfirmationSliceInitialState,
    reducers: {
        setAlertConfirmation: (state, action: PayloadAction<AlertConfirmationSliceInterface>) => {
            state.show = action.payload.show;
            state.onPressBtnPrimary = () => { (action.payload.onPressBtnPrimary) && action.payload.onPressBtnPrimary() };
            state.onPressBtnSecondary = () => { (action.payload.onPressBtnSecondary) && action.payload.onPressBtnSecondary() };
            state.title = action.payload.title;
            state.message = action.payload.message;
            state.subText = action.payload.subText;
            state.subMessage = action.payload.subMessage;
            state.btnPrimaryText = action.payload.btnPrimaryText;
            state.btnSecondaryText = action.payload.btnSecondaryText;
        },
        showAlertConfirmation: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        clearAlertConfirmation: (state) => {
            state.show = alertConfirmationSliceInitialState.show;
            state.onPressBtnPrimary = alertConfirmationSliceInitialState.onPressBtnPrimary;
            state.onPressBtnSecondary = alertConfirmationSliceInitialState.onPressBtnSecondary;
            state.title = alertConfirmationSliceInitialState.title;
            state.message = alertConfirmationSliceInitialState.message;
            state.subText = alertConfirmationSliceInitialState.subText;
            state.subMessage = alertConfirmationSliceInitialState.message;
            state.btnPrimaryText = alertConfirmationSliceInitialState.btnPrimaryText;
            state.btnSecondaryText = alertConfirmationSliceInitialState.btnSecondaryText;
        }
    }
});


//-------------------------------------------------------------------------------------------------- Exports
export const { setAlertConfirmation, showAlertConfirmation, clearAlertConfirmation } = alertConfirmationSlice.actions;
export const getAlertConfirmationData = (state: any) => (state.alertConfirmation) as AlertConfirmationSliceInterface;
export default alertConfirmationSlice.reducer;
